import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import FinancialKpis from "./financialKpi";
import BgSummaryByCount from "./bgSummaryByCount";
import BgSummaryByValue from "./bgSummaryByValue";
import BankWiseExposureByValue from "./bankWiseExposureByValue";
import BankWiseExposureByCount from "./bankWiseExposureByCount";
import { useGetFinancialDashboardDataQuery } from "store/slices/apis/financialDashboardSlice";
import { useParams } from "react-router-dom";



const FinancialDashboard = () => {
    const { projectId } = useParams();

    const { data, isLoading, isError } = useGetFinancialDashboardDataQuery({ projectId });

    return (
        <>
            <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>
                <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: "18px", sm: "32px", md: "36px" },
                                    lineHeight: { xs: "16px", md: "48px" },
                                    color: "#252C32",
                                    fontFamily: "Outfit, sans-serif",
                                }}
                            >
                                Bank Guarantee Exposure
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "24px",
                                color: "#252C32",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: "Poppins, sans-serif",
                                    fontWeight: 600,
                                    fontSize: "20px",
                                    lineHeight: "32px",
                                    color: "#05004E",
                                }}
                            >
                                {/* Bank Guarantee Dashboard */}
                            </Typography>

                            <Typography
                                sx={{
                                    fontFamily: "Poppins, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "26px",
                                    color: "#737791",
                                    mb: 2,
                                }}
                            >
                                Monitor outstanding guarantees, issuing-bank concentration, and upcoming expiry exposure.
                            </Typography>
                        </Typography>
                    </Box>
                </Grid>
                <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <FinancialKpis data ={data?.data} isLoading={isLoading} isError={isError} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                p: 0,
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                overflow: "hidden",
                                height: "100%",
                            }}
                        >
                            <BgSummaryByValue data={data?.data?.bgTypeSummary || []} isLoading={isLoading} isError={isError} />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                p: 0,
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                overflow: "hidden",
                                height: "100%",
                            }}
                        >
                            <BgSummaryByCount data={data?.data?.bgTypeSummary || []} isLoading={isLoading} isError={isError} />
                        </Box>
                    </Grid>
                     <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                p: 0,
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                overflow: "hidden",
                                height: "100%",
                            }}
                        >
                            <BankWiseExposureByValue  data={data?.data?.bankWiseExposure || []} isLoading={isLoading} isError={isError} />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                p: 0,
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                overflow: "hidden",
                                height: "100%",
                            }}
                        >
                            <BankWiseExposureByCount data={data?.data?.bankWiseExposure || []} isLoading={isLoading} isError={isError} />
                        </Box>
                    </Grid>

                </Grid>
            </Grid >
        </>
    )

}

export default FinancialDashboard;
